/**
 * @short Import a module by name
 *
 * We need this function to tell parcel to compile and hash and everything
 * these modules. Later are loaded by name, normally in the html, not by path.
 *
 * @param name - The name of the module to import
 * @returns The imported module
 */
export const import_by_name = async (name) => {
  switch (name) {
    case "ajax_tables":
      return import("ajax_tables");
    case "editable_tables":
      return import("editable_tables");
    case "utils":
      return import("utils");
    case "forms":
      return import("forms");
    case "form":
      return import("form");
    case "formsjson":
      return import("formsjson");
    case "tabs":
      return import("tabs");
    case "index":
      return import("index");
    case "3panels":
      return import("3panels");
    // case "messages":
    //   return import("healthmotiv/tasks/js/messages");
    case "cms":
      return import("coronis/cms/js/cms");
    case "cmsp":
      return import("coronis/cms/js/cmsp");
    case "upload":
      return import("upload");
    case "users":
      return import("users");
    case "filtered_file_list":
      return import("healthmotiv/enduser/js/filtered_file_list");
    case "gui":
      return import("gui");
    case "add_message":
      return import("healthmotiv/enduser/js/add_message");
    case "collaborator_filter_list":
      return import("healthmotiv/collaborator/js/collaborator_filter_list");
    case "jquery.tablesorter":
      return import("jquery.tablesorter");
    case "file_messages":
      return import("healthmotiv/enduser/js/file_messages");
    case "metrics":
      return import("healthmotiv/metrics/js/metrics");
    case "pain":
      return import("healthmotiv/pain/js/pain");
    case "cinput":
      return import("healthmotiv/base/js/cinput");
    case "userform_edit":
      return import("coronis/userforms/js/userform_edit");
    case "userforms_reports":
      return import("coronis/userforms/js/userforms_reports");
    case "userforms":
      return import("coronis/userforms/js/userforms");
    case "group_permissions":
      return import("coronis/base/js/group_permissions");
    case "enduser_register":
      return import("healthmotiv/enduser/js/enduser_register");
    case "fastuser":
      return import("healthmotiv/fastuser/js/fastuser");
    case "jquery-ui":
      return import("jquery-ui-import");
    case "slider":
      return import("healthmotiv/base/js/slider");
    case "jquery-validation":
      return import("jquery-validation");
    case "messages":
      return import("healthmotiv/tasks/js/messages");
    case "contracts":
      return import("healthmotiv/corporate/js/contracts");
    case "graphs":
      return import("graphs");
    case "log_report":
      return import("coronis/reports/js/log_report");
    case "cmd":
      return import("healthmotiv/enduser/js/cmd");
    case "pathology":
      return import("healthmotiv/enduser/js/pathology");
    case "coronis":
      return import("coronis");
    case "colabjoin":
      return import("healthmotiv/collaborator/js/colabjoin");
    case "useraddress":
      return import("coronis/users/static/js/useraddress");
    default:
      throw new Error(`Unknown module: ${name}`);
  }
};

export const get_function_by_name = async (mod_name) => {
  if (!mod_name) {
    // console.error("No module name provided");
    return null;
  }
  if (!mod_name.includes(".")) {
    // console.error("No function name provided");
    return null;
  }
  const [module_name, name] = mod_name.split(".");
  const module = await import_by_name(module_name);
  return module[name];
};

window.import_by_name = import_by_name;
